<template>
  <section>
    <v-dialog v-model="repetidosModal" scrollable persistent max-width="800">
      <v-card>
        <v-toolbar dark color="primary">
          <v-card-title><h4>Verificación de Certificado</h4></v-card-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="cancel()">
              <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar> 
        <br>      
        <v-card-text>
          <v-form v-model='valid' ref='formulario' lazy-validation>                    
            <v-layout row wrap>
              <v-flex md6 sm12 xs12>
               <v-text-field
                  v-model="codigoControl"
                  prepend-icon="credit_card"
                  label="Código de Control CGE*"
                  required
                  maxlength="30"
                  :rules="dRules"
                ></v-text-field>
              </v-flex>
              <v-flex md6 sm12 xs12>
                <global-date-input-picker
                  v-model="date" :hint="'Formato DD/MM/AAAA'" :rules="dRules" label="Fecha De Recepción*">
                </global-date-input-picker> 
              </v-flex>
            </v-layout>
            <br />
             <v-layout wrap>
               <v-flex sm12 md12>
                 <v-subheader>
                   <p class='plomo--text'>Por favor llene los campos requeridos*</p>
                 </v-subheader>
               </v-flex>
             </v-layout>
            <v-layout>
              <v-flex md12>
                <p>Digite la letras y/o números que aparecen en la imagen </p>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex md3 offset-md1>
                <img
                  :src="imgb64"
                  alt="Bolivia">
              </v-flex>
              <v-flex md4 offset-md1>
                <v-text-field
                  v-model="captcha"
                  :rules='this.useCaptcha ? dRules : []'
                  label='Respuesta'
                  :maxlength="this.lengthCaptcha"
                ></v-text-field>
              </v-flex>
              <v-flex md1>
                <v-icon large @click="crearImagenCaptcha()">cached</v-icon>                  
              </v-flex>
            </v-layout>
          </v-form>
          </v-card-text>
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
                      :loading="loadingCertificado"
                        color="primary"
                        class="ma-2 white--text"
                        @click="verificar"
                      >
                        <v-icon>search</v-icon>&nbsp;Buscar
                        <template v-slot:loader>
                     <span>procesando..</span>
                     </template>
                      </v-btn>
          <v-btn color="error" @click="cancel()"><v-icon>cancel</v-icon>&nbsp;Cancelar</v-btn>          
        </v-card-actions>
     </v-card>
    </v-dialog>
          <v-dialog v-model="dialog" scrollable max-width="1100px">
            <v-card>
              <v-toolbar dark color="primary">
                <v-toolbar-title><h4>Información del documento</h4></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="dialog = false, limpiar()">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-toolbar>
              <div style="padding: 15px;">
                <h4>DATOS DE LA VALIDACIÓN DE FIRMA DIGITAL DEL CERTIFICADO</h4>
                <p v-if="this.tipoMensaje === 'warning'"><v-icon color="red">block</v-icon><b> El certificado no es válido,</b> debido a que el documento ha sido modificado o cuenta con una firma no autorizada.</p>
                <div v-if="this.tipoMensaje === 'success'">
                  <div v-for="item in firmanteEntidad" v-bind:key="item.id">
                    <p><v-icon color="green">check_circle</v-icon> El certificado es válido y fue firmado digitalmente por <strong>{{item.signatario}}</strong></p>
                  </div>
                </div>
                <p>NOTA.- Para verificar la veracidad de un certificado digital el QR le redireccionará al Sistema de Declaraciones Juradas de Bienes y Rentas de la CGE.</p>
              </div>
              <v-divider></v-divider>
                <v-card-text style="height: 1100px;">
                  <pdf-view
                    v-if="this.dataPdfBase64"
                    :data="dataPdfBase64"
                    :storage="2"
                    :url="url"
                  ></pdf-view>
                  <v-divider></v-divider>
              <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn color="error" text @click="dialog = false, limpiar()"><v-icon>cancel</v-icon>&nbsp;cerrar</v-btn>
              </v-card-actions>
                </v-card-text>
            </v-card>
          </v-dialog>
          <v-dialog v-model="normalModal" scrollable persistent max-width="850">
            <v-card>              
               <v-toolbar dark color="primary">
                <v-toolbar-title><h4>DATOS DE LA DECLARACIÓN</h4></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="dialog = false, limpiar2()">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-layout wrap>
                  <v-flex sm6 md6>
                    <b class="subtitulo">Número de Certificado:</b>
                  </v-flex>
                  <v-flex sm6 md6>
                   {{ respuesta.numeroCertificadoDep }}
                  </v-flex>
                </v-layout>                
                <v-layout wrap>
                  <v-flex sm6 md6>
                    <b class="subtitulo">Número de Control CGE:</b>
                  </v-flex>
                  <v-flex sm6 md6>
                   {{ respuesta.codigoControlCge }}
                  </v-flex>
                </v-layout> 
                <v-layout wrap>
                  <v-flex sm6 md6>
                    <b class="subtitulo">Motivo de la Declaración:</b>
                  </v-flex>
                  <v-flex sm6 md6>
                   {{ respuesta.motivoDeclaracion }}
                  </v-flex>
                </v-layout> 
                <v-layout wrap>
                  <v-flex sm6 md6>
                    <b class="subtitulo">Tipo de Documento de Identificación:</b>
                  </v-flex>
                  <v-flex sm6 md6>
                   {{ respuesta.tipdoc }}
                  </v-flex>
                </v-layout> 
                <v-layout wrap>
                  <v-flex sm6 md6>
                    <b class="subtitulo">NUMERO DE DOCUMENTO:</b>
                  </v-flex>
                  <v-flex sm6 md6>
                   {{ respuesta.docidentidad }}
                  </v-flex>
                </v-layout> 
                <!-- <v-layout wrap>
                  <v-flex sm6 md6>
                    <b class="subtitulo">Expedido en:</b>
                  </v-flex>
                  <v-flex sm6 md6>
                   {{ respuesta.expedicion }}
                  </v-flex>
                </v-layout>  -->
                <v-layout wrap>
                  <v-flex sm6 md6>
                    <b class="subtitulo">Apellidos:</b>
                  </v-flex>
                  <v-flex sm6 md6>
                   {{ respuesta.apellidos }}
                  </v-flex>
                </v-layout> 
                <v-layout wrap>
                  <v-flex sm6 md6>
                    <b class="subtitulo">Nombres:</b>
                  </v-flex>
                  <v-flex sm6 md6>
                   {{ respuesta.nombres }}
                  </v-flex>
                </v-layout> 
                <v-layout wrap>
                  <v-flex sm6 md6>
                    <b class="subtitulo">Fecha de Recepción:</b>
                  </v-flex>
                  <v-flex sm6 md6>
                  {{ respuesta.fechaRecepcion }}
                  </v-flex>
                </v-layout> 
                <v-layout wrap>
                  <v-flex sm6 md6>
                    <b class="subtitulo">Entidad:</b>
                  </v-flex>
                  <v-flex sm6 md6>
                   {{ respuesta.entidad }}
                  </v-flex>
                </v-layout> 
                <v-layout wrap>
                  <v-flex sm6 md6>
                    <b class="subtitulo">Cargo:</b>
                  </v-flex>
                  <v-flex sm6 md6>
                   {{ respuesta.cargo }}
                  </v-flex>
                </v-layout> 
              </v-card-text>
            </v-card>
          </v-dialog>
    <div class="centered">
      <v-layout wrap>
        <v-flex md12>
          <v-btn small flat color="primary" @click.stop='repetidosModal = true'>
            <p class="padding-label" style="color:white;">
              <v-icon>card_membership</v-icon>&nbsp;
              <b>Verificación de Certificado</b>
            </p>
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
  </section>
</template>
<script>
import Captcha from './mixins/captcha.js';
import PdfView from '@/common/util/PdfView.vue';
export default {
  components: {
    PdfView
  },
  mixins: [ Captcha ],
  created () {
    const req = this.$route.query.dmFsaWRhY2lvbmNlcnRpZmljYWRv;
    if (req) {
      const buff = Buffer.from(req, 'base64');
      const text = buff.toString('ascii');
      if (text.search(':') > 0) {
        const [codigoControl, date] = text.split(':');
        this.date = date;
        this.codigoControl = codigoControl;
        this.buscar();
      }
    }
    this.crearImagenCaptcha();
  },
  data: () => ({
    normalModal: false,
    repetidosModal: false,
    dialog: false,
    loader: null,
    loadingUpload: false,
    loadingCertificado: false,
    url: 'http://localhost/api/download/pdf',
    menu: false,
    date: '',
    dRules: [v => !!v || 'Este campo es requerido'],
    validacion: false,
    pdfFile: '',
    fileName1: '',
    fileBase64: '',
    dataPdfBase64: '',
    codigoControl: '',
    firmanteEntidad: [],
    tipoMensaje: '',
    respuesta: {
      tipdoc: '',
      docidentidad: '',
      expedicion: '',
      apellidos: '',
      nombres: '',
      motivoDeclaracion: '',
      fechaRecepcion: '',
      fechaUltimaVisita: '',
      entidad: '',
      cargo: '',
      numeroCertificadoDep: '',
      numeroCertificadoNac: '',
      codigoControlCge: ''
    },
    captcha: '',
    imgb64: '',
    textCaptcha: '',
    useCaptcha: process.env.USE_CAPTCHA,
    lengthCaptcha: process.env.LENGTH_CAPTCHA,
    valid: false,
    entidad: []
  }),
  methods: {
    async crearImagenCaptcha () {
      this.captcha = '';
      let result = await this.makeText();
      this.tokenCaptcha = result.token;
      this.imgb64 = this.generateCaptcha(result.captcha);
    },
    buscar () {
      if (this.date && this.codigoControl) {
        const params = {
          fecha_recepcion: this.date,
          control_cge: this.codigoControl
        };
        this.$storage.set('token', process.env.TOKEN_EXTERNO);
        this.$service.post(`djbr_registro/validar_control`, params).then(response => {
          this.$storage.remove('token');
          if (response) {
            this.loadingCertificado = false;
            this.tipoMensaje = response.err_existente === 0 ? 'success' : 'error';
            this.$message[this.tipoMensaje](response.err_mensaje);
            // base64 del id de archivo para enviar al servicio
            if (response.id_archivo_dig_cert) {
              const paramsArchivo = { value: Buffer.from(`value:${response.sha256_cert}:${response.id_archivo_dig_cert}:${new Date()}`).toString('base64') };
              this.$storage.set('token', process.env.TOKEN_EXTERNO);
              this.$service.post(`djbr_registro/validar_documento`, paramsArchivo).then(response => {
                this.$storage.remove('token');
                if (response) {
                  let archivoValidado = response.documento;
                  this.$service.post(`system/validar`, {file: `data:application/pdf;base64,${archivoValidado}`}).then(response => {
                    if (response) {
                      this.tipoMensaje = response.verificacion && response.certificado.length > 0 ? 'success' : 'warning';
                      this.tipoMensaje = response.certificado.length === 0 ? 'error' : this.tipoMensaje;
                      this.$message[this.tipoMensaje](response.message);
                      this.dataPdfBase64 = archivoValidado.replace('data:application/pdf;base64,', '');
                      this.entidad = response.certificado;
                      const certs = response.certificado;
                      let firmanteEntidadArr = [];
                      let firmanteEntidadData = {};
                      let i = 0;
                      certs.forEach(function (cert) {
                        firmanteEntidadData = { id: i, signatario: cert.nombreComunSubject, entidad: '' };
                        firmanteEntidadData = cert.organizacionSubject ? { id: i, signatario: cert.nombreComunSubject, entidad: cert.organizacionSubject } : firmanteEntidadData;
                        firmanteEntidadArr.push(firmanteEntidadData);
                        i = i + 1;
                      });
                      this.dialog = true;
                      this.validacion = true;
                      this.firmanteEntidad = firmanteEntidadArr;
                    } else {
                      this.$message['warning']('No es posible realizar la validación');
                      this.loadingCertificado = false;
                    }
                  }).catch(error => {
                    console.error(error);
                    this.loadingCertificado = false;
                    this.crearImagenCaptcha();
                  });
                }
              }).catch(error => {
                this.$storage.remove('token');
                console.error(error);
                this.loadingCertificado = false;
              });
            }
          }
        }).catch(error => {
          console.error(error);
          this.loadingCertificado = false;
          this.$storage.remove('token');
        });
      } else {
        this.$message['warning']('Es necesario el código de control y la fecha de recepción');
      }
      this.$storage.remove('token');
    },
    limpiar () {
      this.pdfFile = '';
      this.fileName1 = '';
      this.fileBase64 = '';
      this.dataPdfBase64 = '';
      this.firmanteEntidad = [];
      this.tipoMensaje = '';
      this.validacion = false;
    },
    verificar () {
      if (this.$refs.formulario.validate()) {
        // let verify = this.verificarCaptcha(this.useCaptcha, this.textCaptcha, this.captcha);
        // if (verify) {
        this.loadingCertificado = true;
        const params = {
          fecha_recepcion: this.date,
          control_cge: this.codigoControl,
          token: this.tokenCaptcha,
          captcha: this.captcha
        };
        this.$storage.set('token', process.env.TOKEN_EXTERNO);
        this.$service.post(`djbr_registro/verifica_tipo_declaracion`, params).then(response => {
          this.$storage.remove('token');
          if (response.sistema_recepcion === 1) {
            this.buscar();
          }
          if (response.sistema_recepcion === 0) {
            this.buscarNormal();
          }
          if (response.sistema_recepcion === -1) {
            this.$message['warning']('NO SE ENCONTRARON RESULTADOS CON LOS PARAMETROS ENVIADOS');
            this.loadingCertificado = false;
            this.crearImagenCaptcha();
            this.setearDatos();
          }
        }).catch(error => {
          console.error(error);
          this.loadingCertificado = false;
          this.crearImagenCaptcha();
          this.$storage.remove('token');
        });
        // } else {
        //   this.crearImagenCaptcha();
        //   this.$message['warning']('El código ingresado no es correcto');
        //   this.loadingCertificado = false;
        // }
      } else {
        this.$message['warning']('Favor Ingrese los Datos Obligatorios');
      }
      this.$storage.remove('token');
    },
    limpiar2 () {
      this.respuesta = [];
      this.normalModal = false;
    },
    buscarNormal () {
      if (this.date && this.codigoControl) {
        const params = { fecha_recepcion: this.date, control_cge: this.codigoControl };
        this.$storage.set('token', process.env.TOKEN_EXTERNO);
        this.$service.post(`djbr_registro/validar_control_externo`, params).then(response => {
          this.$storage.remove('token');
          if (response) {
            this.loadingCertificado = false;
            this.respuesta.tipdoc = response.tipdoc_descripcion;
            this.respuesta.docidentidad = response.perdec_docidentidad;
            this.respuesta.expedicion = response.dep_sigla_expedicion;
            this.respuesta.apellidos = response.perdec_apellidos;
            this.respuesta.nombres = response.perdec_nombres;
            this.respuesta.motivoDeclaracion = response.motdec_descripcion;
            this.respuesta.fechaRecepcion = response.decjur_fecha_recepcion_formateado;
            this.respuesta.fechaUltimaVisita = response.decjur_fecha_ultima_visita;
            this.respuesta.entidad = response.ent_descripcion;
            this.respuesta.cargo = response.cardec_descripcion_cargo;
            this.respuesta.numeroCertificadoDep = response.decjur_numero_certificado_departamento;
            this.respuesta.numeroCertificadoNac = response.numero_certificado_nacional;
            this.respuesta.codigoControlCge = response.decjur_control_cge;
            this.normalModal = true;
            this.crearImagenCaptcha();
          } else {
            this.$message['warning']('No es posible realizar la validación');
            this.loadingCertificado = false;
            this.crearImagenCaptcha();
          }
        }).catch(error => {
          this.$storage.remove('token');
          console.error(error);
          this.loadingCertificado = false;
          this.crearImagenCaptcha();
        });
      } else {
        this.$message['warning']('Favor Ingrese los Datos Obligatorios');
        this.loadingCertificado = false;
      }
    },
    cancel () {
      this.repetidosModal = false;
      this.loadingUpload = false;
      this.loadingCertificado = false;
      this.$refs.formulario.resetValidation();
      this.setearDatos();
      this.crearImagenCaptcha();
    },
    setearDatos () {
      this.respuesta.tipdoc = '';
      this.respuesta.docidentidad = '';
      this.respuesta.expedicion = '';
      this.respuesta.apellidos = '';
      this.respuesta.nombres = '';
      this.respuesta.motivoDeclaracion = '';
      this.respuesta.fechaRecepcion = '';
      this.respuesta.fechaUltimaVisita = '';
      this.respuesta.entidad = '';
      this.respuesta.cargo = '';
      this.respuesta.numeroCertificadoDep = '';
      this.respuesta.numeroCertificadoNac = '';
      this.respuesta.codigoControlCge = '';
      this.codigoControl = '';
      this.date = '';
      this.$elmenu = false;
      this.textCaptcha = '';
      this.captcha = '';
      this.limpiar();
      this.limpiar2();
      this.$refs.formulario.resetValidation();
    },
    formatDate (date) {
      if (!date) return null;
      const fecha = date.split('T');
      const [year, month, day] = fecha[0].split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate (date) {
      if (!date) return null;
      const [day, month, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
  },
  watch: {
    loader () {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => (this[l] = false), 3000);
      this.loader = null;
    }
  }
};
</script>

<style lang='scss'>
.pdf-view .pdf-view-actions .pdf-view-buttons .visible {
  visibility: hidden !important;
}
.subtitulo {
  color: #1976D2;
  text-transform: uppercase;
}
.espacio {
  width: 10px;
  height: 100px;
  border:white 1px solid;
}
</style>




// WEBPACK FOOTER //
// src/components/portal/comprobacion.vue